// MaxFlowMinCutInteractivePage.jsx
import React from 'react';
import { Typography, Paper } from '@mui/material';
import Grid from '@mui/material/Grid';

import MaxFlowMinCutInteractive from './MaxFlowMinCutInteractive';

function MaxFlowMinCutInteractivePage() {
  return (
    <section style={{ padding: '20px' }}>
      <Typography variant="h4" gutterBottom>
        Max-Flow / Min-Cut Interactive
      </Typography>
      <Typography variant="body1" paragraph>
        Explore augmenting paths, residual graphs, and see how the flow value
        increases until a maximum is reached, alongside a corresponding min-cut. This visulization is from Gemini3.
      </Typography>

      <Grid container justifyContent="center">
        <Grid item xs={12} md={10}>
          <Paper style={{ padding: '16px', minHeight: '300px' }}>
            {/* <MaxFlowMinCutInteractive /> */}
              <MaxFlowMinCutInteractive/>
          </Paper>
        </Grid>
      </Grid>
    </section>
  );
}

export default MaxFlowMinCutInteractivePage;
